import { Fragment, useCallback, useEffect, useState } from 'react';
import Pagination from 'components/Pagination/Pagination';
import Table from 'components/Table/Table';
import TableSkeleton from 'components/Table/TableSkeleton/TableSkeleton';
import { selectAuthUser } from 'features/auth/authSlice';
import { setNavbarTitle } from 'features/navbar/navbarSlice';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import cardStyles from 'styles/modules/Card.module.scss';
import { actions } from 'utils/helpers';
import { UNAUTHORIZED } from 'constants';
import { useGetQueueAgentsQuery } from 'features/call_center/queueTiersApiSlice';

const QueueAgents = ({ label }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  const {
    data: queueAgents,
    isFetching: isLoading,
    isError,
    error,
  } = useGetQueueAgentsQuery({ id: params.id, searchParams: searchParams.toString() });

  // const [deleteAgent] = useDeleteQueueTierMutation();
  const authUser = useSelector(selectAuthUser);

  useEffect(() => {
    dispatch(setNavbarTitle('Queue Agents'));
  }, [dispatch]);

  useEffect(() => {
    if (isError && !errorDisplayed) {
      toast.error(error?.message || 'Could not load queue agents, try refreshing the page');
      setErrorDisplayed(true);
    }
  }, [isError, error, errorDisplayed]);

  const onItemClickHandler = (id) => {
    navigate(`/call_center/queues/${params.id}/agents/${id}`);
  };

  // const onDeleteBtnHandler = useCallback(
  //   async (id, callFn = false) => {
  //     if (authUser?.actions[label]?.includes(actions.delete)) {
  //       if (callFn) {
  //         await deleteTier({ queueId: params.id, tierId: id }).unwrap();
  //       }
  //       return '';
  //     }
  //     return UNAUTHORIZED;
  //   },
  //   [authUser?.actions, deleteTier, label, params.id]
  // );

  return (
    <div>
      <div className={cardStyles.menu}>
        <h3>Queue Agents</h3>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Fragment>
          <Table
            data={queueAgents || []}
            onItemClickHandler={onItemClickHandler}
          // onDelete={onDeleteBtnHandler}
          />
          <Pagination totalCount={queueAgents?.size || 0} />
        </Fragment>
      )}
    </div>
  );
};

export default QueueAgents;
